export default __webpack_public_path__ + "static/media/kkraus_logo.fb9c48ff.png";